import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onMounted, onBeforeUnmount } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DFloater',
  props: {
  visible: { type: Boolean, default: false },
  title: { type: String, default: "无标题" },
},
  emits: ["update:visible", "close"],
  setup(__props, { emit }) {





const instance = getCurrentInstance();
let el: Element | undefined;

function closeDialog() {
  emit("update:visible", false);
  emit("close");
}

onMounted(() => {
  el = instance?.proxy?.$el;
  if (el) {
    document.body.appendChild(el);
  }
});

onBeforeUnmount(() => {
  const parent = el?.parentNode;
  if (parent && el) {
    parent.removeChild(el);
  }
});

return { __sfc: true,emit, instance, el, closeDialog }
}

})